import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import type { CategoryGuid } from '@atlassian/jira-servicedesk-knowledge-services/src/types.tsx';

export const ADD_CATEGORIES_FOR_ARTICLE =
	'state.actions.add-categories-for-article.ADD_CATEGORIES_FOR_ARTICLE';

export type AddCategoriesForArticle = {
	articleId: string;
	spaceKey: string;
	categoryIds: CategoryGuid[];
	analyticsEvent: UIAnalyticsEvent;
};

export type AddCategoriesForArticleAction = {
	type: typeof ADD_CATEGORIES_FOR_ARTICLE;
	payload: AddCategoriesForArticle;
};

export const addCategoriesForArticle = (
	payload: AddCategoriesForArticle,
): AddCategoriesForArticleAction => ({
	payload,
	type: ADD_CATEGORIES_FOR_ARTICLE,
});
